const UNIT_LIST = ['mBTC', 'uBTC'];

const isUnit = (currency: string) => UNIT_LIST.includes(currency);

export default isUnit;
